import React from 'react'
import ReactDOM from 'react-dom'
import Tilbod from './tilbod'
import { store } from '../../store' 

$.fn.tilbod = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(Tilbod, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-tilbod]').tilbod();
});